import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class CacheService {

  private cache = {};

  constructor(private http: HttpClient) { }

  getValue(url, obj?) {
    let subscription = new BehaviorSubject([]);
    let value = this.cache[url(obj) + ''];
    if (value)
      subscription.next(value);
    else {
      let sub = obj ? this.http.get(url(obj)) : this.http.get(url())
      sub.subscribe(res => {
        this.cache[url(obj) + ''] = res['data'];
        subscription.next(res['data']);
      });
    }
    return subscription;

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/cache.service.ts